import script from "./pc-module-cross-analysis-1.vue?vue&type=script&setup=true&lang=tsx"
export * from "./pc-module-cross-analysis-1.vue?vue&type=script&setup=true&lang=tsx"

import "./pc-module-cross-analysis-1.vue?vue&type=style&index=0&id=afe8ac5e&lang=scss"

const __exports__ = script;

export default __exports__